/* ==========================================================================
   SHX §3.22 — "Read more" clamp behaviour.

   Deliberately small and defensive:
   * The text is never injected or removed — only visually clipped — so search
     engines index the whole description regardless of state.
   * If the description is short enough to fit, the clamp and the button are
     removed entirely. A "Read more" that reveals nothing is worse than none.
   * Re-measures on resize and on font load, because a narrower viewport turns
     a 4-line description into a 9-line one.
   * Collapsing scrolls the description back into view, so the visitor is not
     left staring at the middle of the page.
   ========================================================================== */

(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function measure(clamp) {
    var text = clamp.querySelector('.shx-clamp__text');
    var toggle = clamp.querySelector('.shx-clamp__toggle');
    if (!text || !toggle) return;

    // Measure against the collapsed state, never while open.
    if (clamp.classList.contains('is-open')) return;

    clamp.classList.add('is-measuring');
    var overflows = text.scrollHeight - text.clientHeight > 4;
    clamp.classList.remove('is-measuring');

    clamp.classList.toggle('shx-clamp--off', !overflows);
    toggle.hidden = !overflows;
  }

  function toggleClamp(clamp) {
    var text = clamp.querySelector('.shx-clamp__text');
    var toggle = clamp.querySelector('.shx-clamp__toggle');
    var label = toggle.querySelector('.shx-clamp__label');
    var open = clamp.classList.toggle('is-open');

    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (label) label.textContent = open ? toggle.dataset.less : toggle.dataset.more;

    if (!open) {
      var top = clamp.getBoundingClientRect().top;
      if (top < 0) {
        clamp.scrollIntoView({
          block: 'start',
          behavior: REDUCED && REDUCED.matches ? 'auto' : 'smooth',
        });
      }
    }

    // Keep the transition honest: animate to the real height, then release it
    // so later content changes (variant switch) are not capped.
    if (open && text) {
      text.style.maxHeight = text.scrollHeight + 'px';
      window.setTimeout(function () {
        if (clamp.classList.contains('is-open')) text.style.maxHeight = '';
      }, 450);
    } else if (text) {
      text.style.maxHeight = '';
    }
  }

  function init(root) {
    (root || document).querySelectorAll('.shx-clamp').forEach(function (clamp) {
      if (clamp.dataset.shxClampReady) return;
      clamp.dataset.shxClampReady = '1';

      var toggle = clamp.querySelector('.shx-clamp__toggle');
      if (!toggle) return;

      toggle.addEventListener('click', function () {
        toggleClamp(clamp);
      });

      measure(clamp);

      if ('ResizeObserver' in window) {
        var ro = new ResizeObserver(function () {
          measure(clamp);
        });
        ro.observe(clamp);
      } else {
        window.addEventListener('resize', function () {
          measure(clamp);
        });
      }

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () {
          measure(clamp);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    init(event.target);
  });
})();
